import type {ChatiwiLocaleId} from '../components/localeLoaders';
import type {MicrositeRoutePath} from 'microsites/core/chatMicrosite/routes/types';
import type {MicrositeRouteRegistry} from 'microsites/core/chatMicrosite/runtime/MicrositeRouteRegistryContext';

export const chatiwiRouteDefinitions = {
  landing: {
    id: `landing`,
    templateRelativePath: `src/templates/landingPage.template.tsx`,
    paths: {
      'ar-MA': `/ar-MA`,
      'ar-SA': `/ar-SA`,
      'de-DE': `/de-DE`,
      'en-KE': `/en-KE`,
      'en-NG': `/en-NG`,
      'en-US': `/`,
      'es-ES': `/es-ES`,
      'fa-IR': `/fa-IR`,
      'fr-FR': `/fr-FR`,
      'hi-IN': `/hi-IN`,
      'it-IT': `/it-IT`,
      'ja-JP': `/ja-JP`,
      'ko-KR': `/ko-KR`,
      'nl-NL': `/nl-NL`,
      'pt-PT': `/pt-PT`,
      'ru-RU': `/ru-RU`,
      'sv-SE': `/sv-SE`,
      'th-TH': `/th-TH`,
      'tr-TR': `/tr-TR`,
      'yue-Hant-HK': `/yue-Hant-HK`,
      'zh-Hans-CN': `/zh-Hans-CN`,
      'ar-AE': `/ar-AE`,
      'ar-QA': `/ar-QA`,
      'bn-BD': `/bn-BD`,
      'da-DK': `/da-DK`,
      'de-AT': `/de-AT`,
      'de-CH': `/de-CH`,
      'en-SG': `/en-SG`,
      'fi-FI': `/fi-FI`,
      'id-ID': `/id-ID`,
      'is-IS': `/is-IS`,
      'mr-IN': `/mr-IN`,
      'no-NO': `/no-NO`,
      'pa-PK': `/pa-PK`,
      'pcm-NG': `/pcm-NG`,
      'pl-PL': `/pl-PL`,
      'pt-BR': `/pt-BR`,
      'sw-KE': `/sw-KE`,
      'te-IN': `/te-IN`,
      'ur-PK': `/ur-PK`,
      'vi-VN': `/vi-VN`,
    } as const satisfies Record<ChatiwiLocaleId, MicrositeRoutePath>,
  },
  about: {
    id: `about`,
    templateRelativePath: `src/templates/aboutPage.template.tsx`,
    paths: {
      'ar-MA': `/ar-MA/على`,
      'ar-SA': `/ar-SA/عن`,
      'de-DE': `/de-DE/über-uns`,
      'en-KE': `/en-KE/about`,
      'en-NG': `/en-NG/about`,
      'en-US': `/en-US/about`,
      'es-ES': `/es-ES/sobre-nosotros`,
      'fa-IR': `/fa-IR/درباره`,
      'fr-FR': `/fr-FR/à-propos`,
      'hi-IN': `/hi-IN/के-बारे-में`,
      'it-IT': `/it-IT/su-di-noi`,
      'ja-JP': `/ja-JP/について`,
      'ko-KR': `/ko-KR/소개`,
      'nl-NL': `/nl-NL/over-ons`,
      'pt-PT': `/pt-PT/sobre-nos`,
      'ru-RU': `/ru-RU/о-нас`,
      'sv-SE': `/sv-SE/om-oss`,
      'th-TH': `/th-TH/เกี่ยวกับ`,
      'tr-TR': `/tr-TR/hakkimizda`,
      'yue-Hant-HK': `/yue-Hant-HK/關於`,
      'zh-Hans-CN': `/zh-Hans-CN/关于我们`,
      'ar-AE': `/ar-AE/من-نحن`,
      'ar-QA': `/ar-QA/من-نحن`,
      'bn-BD': `/bn-BD/আমাদের-সম্পর্কে`,
      'da-DK': `/da-DK/om-os`,
      'de-AT': `/de-AT/über-uns`,
      'de-CH': `/de-CH/über-uns`,
      'en-SG': `/en-SG/about`,
      'fi-FI': `/fi-FI/meistä`,
      'id-ID': `/id-ID/tentang-kami`,
      'is-IS': `/is-IS/um-okkur`,
      'mr-IN': `/mr-IN/आमच्याबद्दल`,
      'no-NO': `/no-NO/om-oss`,
      'pa-PK': `/pa-PK/ساڈے-بارے`,
      'pcm-NG': `/pcm-NG/wetin-be-us`,
      'pl-PL': `/pl-PL/o-nas`,
      'pt-BR': `/pt-BR/sobre-nos`,
      'sw-KE': `/sw-KE/kuhusu-sisi`,
      'te-IN': `/te-IN/మా-గురించి`,
      'ur-PK': `/ur-PK/ہمارے-بارے-میں`,
      'vi-VN': `/vi-VN/về-chúng-tôi`,
    } as const satisfies Record<ChatiwiLocaleId, MicrositeRoutePath>,
  },
  alternatives: {
    id: `alternatives`,
    templateRelativePath: `src/templates/alternativesPage.template.tsx`,
    paths: {
      'ar-MA': `/ar-MA/بدائل-chatiw`,
      'ar-SA': `/ar-SA/بدائل-chatiw`,
      'de-DE': `/de-DE/chatiw-alternativen`,
      'en-KE': `/en-KE/chatiw-alternatives`,
      'en-NG': `/en-NG/chatiw-alternatives`,
      'en-US': `/en-US/chatiw-alternatives`,
      'es-ES': `/es-ES/alternativas-chatiw`,
      'fa-IR': `/fa-IR/جایگزین‌های-chatiw`,
      'fr-FR': `/fr-FR/alternatives-chatiw`,
      'hi-IN': `/hi-IN/chatiw-विकल्प`,
      'it-IT': `/it-IT/alternative-chatiw`,
      'ja-JP': `/ja-JP/chatiw-代替`,
      'ko-KR': `/ko-KR/chatiw-대안`,
      'nl-NL': `/nl-NL/alternatieven-chatiw`,
      'pt-PT': `/pt-PT/alternativas-chatiw`,
      'ru-RU': `/ru-RU/альтернативы-chatiw`,
      'sv-SE': `/sv-SE/chatiw-alternativ`,
      'th-TH': `/th-TH/chatiw-ทางเลือก`,
      'tr-TR': `/tr-TR/chatiw-alternatifleri`,
      'yue-Hant-HK': `/yue-Hant-HK/chatiw-替代方案`,
      'zh-Hans-CN': `/zh-Hans-CN/chatiw-替代`,
      'ar-AE': `/ar-AE/بدائل-chatiw`,
      'ar-QA': `/ar-QA/بدائل-chatiw`,
      'bn-BD': `/bn-BD/chatiw-বিকল্প`,
      'da-DK': `/da-DK/chatiw-alternativer`,
      'de-AT': `/de-AT/chatiw-alternativen`,
      'de-CH': `/de-CH/chatiw-alternativen`,
      'en-SG': `/en-SG/chatiw-alternatives`,
      'fi-FI': `/fi-FI/chatiw-vaihtoehdot`,
      'id-ID': `/id-ID/alternatif-chatiw`,
      'is-IS': `/is-IS/chatiw-valkostir`,
      'mr-IN': `/mr-IN/chatiw-पर्याय`,
      'no-NO': `/no-NO/chatiw-alternativer`,
      'pa-PK': `/pa-PK/chatiw-متبادلات`,
      'pcm-NG': `/pcm-NG/chatiw-betta-choice`,
      'pl-PL': `/pl-PL/alternatywy-chatiw`,
      'pt-BR': `/pt-BR/alternativas-chatiw`,
      'sw-KE': `/sw-KE/mbadala-za-chatiw`,
      'te-IN': `/te-IN/chatiw-ప్రత్యామ్నాయాలు`,
      'ur-PK': `/ur-PK/chatiw-متبادل`,
      'vi-VN': `/vi-VN/lựa-chọn-chatiw`,
    } as const satisfies Record<ChatiwiLocaleId, MicrositeRoutePath>,
  },
  chatWithoutRegistration: {
    id: `chatWithoutRegistration`,
    templateRelativePath: `src/templates/chatWithoutRegistrationPage.template.tsx`,
    paths: {
      'ar-MA': `/ar-MA/دردشة-بدون-تسجيل`,
      'ar-SA': `/ar-SA/دردشة-بدون-تسجيل`,
      'de-DE': `/de-DE/chat-ohne-registrierung`,
      'en-KE': `/en-KE/chat-without-registration`,
      'en-NG': `/en-NG/chat-without-registration`,
      'en-US': `/en-US/chat-without-registration`,
      'es-ES': `/es-ES/chat-sin-registro`,
      'fa-IR': `/fa-IR/چت-بدون-ثبت-نام`,
      'fr-FR': `/fr-FR/chat-sans-inscription`,
      'hi-IN': `/hi-IN/बिना-पंजीकरण-चैट`,
      'it-IT': `/it-IT/chat-senza-registrazione`,
      'ja-JP': `/ja-JP/登録不要チャット`,
      'ko-KR': `/ko-KR/회원가입-없는-채팅`,
      'nl-NL': `/nl-NL/chat-zonder-registratie`,
      'pt-PT': `/pt-PT/chat-sem-registo`,
      'ru-RU': `/ru-RU/чат-без-регистрации`,
      'sv-SE': `/sv-SE/chatta-utan-registrering`,
      'th-TH': `/th-TH/แชท-ไม่ต้องลงทะเบียน`,
      'tr-TR': `/tr-TR/kayit-olmadan-sohbet`,
      'yue-Hant-HK': `/yue-Hant-HK/免註冊聊天`,
      'zh-Hans-CN': `/zh-Hans-CN/无需注册聊天`,
      'ar-AE': `/ar-AE/دردشة-بدون-تسجيل`,
      'ar-QA': `/ar-QA/دردشة-بدون-تسجيل`,
      'bn-BD': `/bn-BD/নিবন্ধন-ছাড়া-চ্যাট`,
      'da-DK': `/da-DK/chat-uden-registrering`,
      'de-AT': `/de-AT/chat-ohne-registrierung`,
      'de-CH': `/de-CH/chat-ohne-registrierung`,
      'en-SG': `/en-SG/chat-without-registration`,
      'fi-FI': `/fi-FI/keskustelu-ilman-rekisteröintiä`,
      'id-ID': `/id-ID/obrolan-tanpa-daftar`,
      'is-IS': `/is-IS/spjall-an-skráningar`,
      'mr-IN': `/mr-IN/नोंदणी-शिवाय-चॅट`,
      'no-NO': `/no-NO/chat-uten-registrering`,
      'pa-PK': `/pa-PK/بغیر-رجسٹریشن-چیٹ`,
      'pcm-NG': `/pcm-NG/chat-no-need-register`,
      'pl-PL': `/pl-PL/czat-bez-rejestracji`,
      'pt-BR': `/pt-BR/chat-sem-cadastro`,
      'sw-KE': `/sw-KE/gumzo-bila-usajili`,
      'te-IN': `/te-IN/నమోదు-లేకుండా-చాట్`,
      'ur-PK': `/ur-PK/بغیر-رجسٹریشن-چیٹ`,
      'vi-VN': `/vi-VN/chat-không-cần-đăng-ký`,
    } as const satisfies Record<ChatiwiLocaleId, MicrositeRoutePath>,
  },
  chatWithoutId: {
    id: `chatWithoutId`,
    templateRelativePath: `src/templates/chatWithoutIdPage.template.tsx`,
    paths: {
      'ar-MA': `/ar-MA/دردشة-بلا-تحقق-بالهوية`,
      'ar-SA': `/ar-SA/دردشة-بلا-تحقق-هوية`,
      'de-DE': `/de-DE/chat-ohne-ausweisprüfung`,
      'en-KE': `/en-KE/chat-bila-id-checks`,
      'en-NG': `/en-NG/chat-without-id-checks-no-long-thing`,
      'en-US': `/en-US/chat-without-id`,
      'es-ES': `/es-ES/chat-sin-comprobaciones-de-id`,
      'fa-IR': `/fa-IR/چت-بدون-بررسی-هویتی`,
      'fr-FR': `/fr-FR/chat-sans-vérification-identité`,
      'hi-IN': `/hi-IN/आईडी-जांच-के-बिना-चैट`,
      'it-IT': `/it-IT/chat-senza-controlli-id`,
      'ja-JP': `/ja-JP/id確認なしチャット`,
      'ko-KR': `/ko-KR/신분증-인증-없는-채팅`,
      'nl-NL': `/nl-NL/chat-zonder-id-controle`,
      'pt-PT': `/pt-PT/chat-sem-verificação-de-identidade`,
      'ru-RU': `/ru-RU/чат-без-проверки-id`,
      'sv-SE': `/sv-SE/chatta-utan-id-kontroller`,
      'th-TH': `/th-TH/แชท-ไม่ต้องยืนยันตัวตน`,
      'tr-TR': `/tr-TR/kimlik-kontrolü-olmadan-sohbet`,
      'yue-Hant-HK': `/yue-Hant-HK/免身份驗證聊天`,
      'zh-Hans-CN': `/zh-Hans-CN/免身份核验聊天`,
      'ar-AE': `/ar-AE/دردشة-بلا-فحص-هوية`,
      'ar-QA': `/ar-QA/دردشة-بلا-تحقق-هوية`,
      'bn-BD': `/bn-BD/আইডি-যাচাই-ছাড়া-চ্যাট`,
      'da-DK': `/da-DK/chat-uden-id-kontrol`,
      'de-AT': `/de-AT/chat-ohne-ausweiskontrolle`,
      'de-CH': `/de-CH/chat-ohne-id-pruefung`,
      'en-SG': `/en-SG/chat-without-id-checks`,
      'fi-FI': `/fi-FI/chat-ilman-henkilöllisyystarkistuksia`,
      'id-ID': `/id-ID/chat-tanpa-pemeriksaan-id`,
      'is-IS': `/is-IS/spjall-án-skilríkjaskoðunar`,
      'mr-IN': `/mr-IN/आयडी-तपासणीशिवाय-चॅट`,
      'no-NO': `/no-NO/chat-uten-id-kontroll`,
      'pa-PK': `/pa-PK/آئی-ڈی-چیک-توں-بغیر-چیٹ`,
      'pcm-NG': `/pcm-NG/chat-wey-no-need-id-check`,
      'pl-PL': `/pl-PL/czat-bez-sprawdzania-dowodu`,
      'pt-BR': `/pt-BR/chat-sem-checagem-de-id`,
      'sw-KE': `/sw-KE/gumzo-bila-ukaguzi-wa-kitambulisho`,
      'te-IN': `/te-IN/ఐడి-తనిఖీలు-లేకుండా-చాట్`,
      'ur-PK': `/ur-PK/شناختی-چیک-کے-بغیر-چیٹ`,
      'vi-VN': `/vi-VN/chat-không-cần-kiểm-tra-id`,
    } as const satisfies Record<ChatiwiLocaleId, MicrositeRoutePath>,
  },
  freeChat: {
    id: `freeChat`,
    templateRelativePath: `src/templates/freeChatPage.template.tsx`,
    paths: {
      'ar-MA': `/ar-MA/دردشة-مجانية-آمنة`,
      'ar-SA': `/ar-SA/دردشة-مجانية-آمنة`,
      'de-DE': `/de-DE/kostenlos-sicher-chatten`,
      'en-KE': `/en-KE/free-secure-chat`,
      'en-NG': `/en-NG/free-secure-chat`,
      'en-US': `/en-US/free-secure-chat`,
      'es-ES': `/es-ES/chat-gratis-seguro`,
      'fa-IR': `/fa-IR/گفتگو-رایگان-ایمن`,
      'fr-FR': `/fr-FR/chat-gratuit-sécurisé`,
      'hi-IN': `/hi-IN/मुफ्त-सुरक्षित-चैट`,
      'it-IT': `/it-IT/chat-gratuito-sicuro`,
      'ja-JP': `/ja-JP/無料安全チャット`,
      'ko-KR': `/ko-KR/무료-안전한-채팅`,
      'nl-NL': `/nl-NL/gratis-veilige-chat`,
      'pt-PT': `/pt-PT/chat-grátis-seguro`,
      'ru-RU': `/ru-RU/бесплатный-безопасный-чат`,
      'sv-SE': `/sv-SE/gratis-säker-chatt`,
      'th-TH': `/th-TH/แชทฟรีที่ปลอดภัย`,
      'tr-TR': `/tr-TR/ucretsiz-guvenli-sohbet`,
      'yue-Hant-HK': `/yue-Hant-HK/免費安全聊天`,
      'zh-Hans-CN': `/zh-Hans-CN/免费安全聊天`,
      'ar-AE': `/ar-AE/دردشة-مجانية-آمنة`,
      'ar-QA': `/ar-QA/دردشة-مجانية-آمنة`,
      'bn-BD': `/bn-BD/বিনামূল্যে-নিরাপদ-চ্যাট`,
      'da-DK': `/da-DK/gratis-sikker-chat`,
      'de-AT': `/de-AT/kostenlos-sicher-chatten`,
      'de-CH': `/de-CH/kostenlos-sicher-chatten`,
      'en-SG': `/en-SG/free-secure-chat`,
      'fi-FI': `/fi-FI/ilmainen-turvallinen-chat`,
      'id-ID': `/id-ID/obrolan-gratis-aman`,
      'is-IS': `/is-IS/ókeypis-öruggt-spjall`,
      'mr-IN': `/mr-IN/मोफत-सुरक्षित-चॅट`,
      'no-NO': `/no-NO/gratis-sikker-chat`,
      'pa-PK': `/pa-PK/مفت-محفوظ-چیٹ`,
      'pcm-NG': `/pcm-NG/free-safe-chat`,
      'pl-PL': `/pl-PL/darmowy-bezpieczny-czat`,
      'pt-BR': `/pt-BR/chat-grátis-seguro`,
      'sw-KE': `/sw-KE/gumzo-bure-salama`,
      'te-IN': `/te-IN/ఉచిత-సురక్షిత-చాట్`,
      'ur-PK': `/ur-PK/مفت-محفوظ-چیٹ`,
      'vi-VN': `/vi-VN/chat-miễn-phí-an-toàn`,
    } as const satisfies Record<ChatiwiLocaleId, MicrositeRoutePath>,
  },
  sexyChallengeGame: {
    id: `sexyChallengeGame`,
    templateRelativePath: `src/templates/sexyChallengeGamePage.template.tsx`,
    paths: {
      'ar-MA': `/ar-MA/مولد-لعبة-تحدي-مثيرة`,
      'ar-SA': `/ar-SA/مولد-لعبة-تحدي-مثيرة`,
      'de-DE': `/de-DE/sexy-challenge-spiel-generator`,
      'en-KE': `/en-KE/sexy-challenge-game-generator`,
      'en-NG': `/en-NG/sexy-challenge-game-generator`,
      'en-US': `/en-US/sexy-challenge-game-generator`,
      'es-ES': `/es-ES/generador-juego-desafios-sexy`,
      'fa-IR': `/fa-IR/مولد-بازی-چالش-سکسی`,
      'fr-FR': `/fr-FR/generateur-jeu-defi-sexy`,
      'hi-IN': `/hi-IN/सेक्सी-चैलेंज-गेम-जनरेटर`,
      'it-IT': `/it-IT/generatore-gioco-sfida-sexy`,
      'ja-JP': `/ja-JP/セクシーチャレンジゲームジェネレーター`,
      'ko-KR': `/ko-KR/섹시-챌린지-게임-제너레이터`,
      'nl-NL': `/nl-NL/sexy-challenge-spel-generator`,
      'pt-PT': `/pt-PT/gerador-jogo-desafio-sexy`,
      'ru-RU': `/ru-RU/генератор-сексуальных-испытаний`,
      'sv-SE': `/sv-SE/sexy-utmaningsspel-generator`,
      'th-TH': `/th-TH/ตัวสร้างเกมชาเลนจ์สุดแซ่บ`,
      'tr-TR': `/tr-TR/seksi-meydan-okuma-oyunu-uretici`,
      'yue-Hant-HK': `/yue-Hant-HK/性感挑戰遊戲產生器`,
      'zh-Hans-CN': `/zh-Hans-CN/性感挑战游戏生成器`,
      'ar-AE': `/ar-AE/مولد-لعبة-تحدي-مثيرة`,
      'ar-QA': `/ar-QA/مولد-لعبة-تحدي-مثيرة`,
      'bn-BD': `/bn-BD/সেক্সি-চ্যালেঞ্জ-গেম-জেনারেটর`,
      'da-DK': `/da-DK/sexy-challenge-spilgenerator`,
      'de-AT': `/de-AT/sexy-challenge-spiel-generator`,
      'de-CH': `/de-CH/sexy-challenge-spiel-generator`,
      'en-SG': `/en-SG/sexy-challenge-game-generator`,
      'fi-FI': `/fi-FI/sexy-haastepeli-generaattori`,
      'id-ID': `/id-ID/generator-gim-tantangan-seksi`,
      'is-IS': `/is-IS/sexý-áskorunarleikja-smiður`,
      'mr-IN': `/mr-IN/सेक्सी-चॅलेंज-गेम-जनरेटर`,
      'no-NO': `/no-NO/sexy-utfordringsspill-generator`,
      'pa-PK': `/pa-PK/سیکسی-چیلنج-گیم-جنریٹر`,
      'pcm-NG': `/pcm-NG/sexy-challenge-game-maker`,
      'pl-PL': `/pl-PL/generator-seksownych-wyzwań`,
      'pt-BR': `/pt-BR/gerador-jogo-desafio-sexy`,
      'sw-KE': `/sw-KE/kizalishaji-mchezo-wa-changamoto-seksi`,
      'te-IN': `/te-IN/సెక్సీ-ఛాలెంజ్-గేమ్-జనరేటర్`,
      'ur-PK': `/ur-PK/سیکسی-چیلنج-گیم-جنریٹر`,
      'vi-VN': `/vi-VN/trình-tạo-trò-chơi-thử-thách-sexy`,
    } as const satisfies Record<ChatiwiLocaleId, MicrositeRoutePath>,
  },
  sexChat: {
    id: `sexChat`,
    templateRelativePath: `src/templates/sexChatPage.template.tsx`,
    paths: {
      'ar-MA': `/ar-MA/دردشة-جنسية`,
      'ar-SA': `/ar-SA/دردشة-جنسية`,
      'de-DE': `/de-DE/sexchat`,
      'en-KE': `/en-KE/sexchat`,
      'en-NG': `/en-NG/sexchat`,
      'en-US': `/en-US/sexchat`,
      'es-ES': `/es-ES/chat-sexo`,
      'fa-IR': `/fa-IR/چت-سکسی`,
      'fr-FR': `/fr-FR/chat-sexe`,
      'hi-IN': `/hi-IN/सेक्स-चैट`,
      'it-IT': `/it-IT/chat-sesso`,
      'ja-JP': `/ja-JP/セックスチャット`,
      'ko-KR': `/ko-KR/섹스채팅`,
      'nl-NL': `/nl-NL/sexchat`,
      'pt-PT': `/pt-PT/chat-sexo`,
      'ru-RU': `/ru-RU/секс-чат`,
      'sv-SE': `/sv-SE/sexchatt`,
      'th-TH': `/th-TH/แชทเซ็กส์`,
      'tr-TR': `/tr-TR/sex-sohbet`,
      'yue-Hant-HK': `/yue-Hant-HK/性愛聊天`,
      'zh-Hans-CN': `/zh-Hans-CN/性爱聊天`,
      'ar-AE': `/ar-AE/دردشة-جنسية`,
      'ar-QA': `/ar-QA/دردشة-جنسية`,
      'bn-BD': `/bn-BD/সেক্স-চ্যাট`,
      'da-DK': `/da-DK/sexchat`,
      'de-AT': `/de-AT/sexchat`,
      'de-CH': `/de-CH/sexchat`,
      'en-SG': `/en-SG/sexchat`,
      'fi-FI': `/fi-FI/seksichat`,
      'id-ID': `/id-ID/chat-seks`,
      'is-IS': `/is-IS/kynlifsspjall`,
      'mr-IN': `/mr-IN/सेक्स-चॅट`,
      'no-NO': `/no-NO/sexchat`,
      'pa-PK': `/pa-PK/سیکس-چیٹ`,
      'pcm-NG': `/pcm-NG/sexchat`,
      'pl-PL': `/pl-PL/czat-seks`,
      'pt-BR': `/pt-BR/chat-sexo`,
      'sw-KE': `/sw-KE/gumzo-la-ngono`,
      'te-IN': `/te-IN/సెక్స్-చాట్`,
      'ur-PK': `/ur-PK/سیکس-چیٹ`,
      'vi-VN': `/vi-VN/chat-tinh-duc`,
    } as const satisfies Record<ChatiwiLocaleId, MicrositeRoutePath>,
  },
} as const satisfies MicrositeRouteRegistry<ChatiwiLocaleId>;

export type ChatiwiRouteDefinitionMap = typeof chatiwiRouteDefinitions;
export type ChatiwiRouteId = keyof ChatiwiRouteDefinitionMap;
